<script setup lang="ts">
interface PropsType {
  show?: boolean;
  title?: string;
  message?: string;
  maxWidth?: string;
  buttonConfirm?: string;
  buttonCancel?: string;
  textAlign?: string;
}

defineEmits(["confirm", "cancel"]);

withDefaults(defineProps<PropsType>(), {
  show: false,
  title: "Antenção",
  message: "Tem certeza desta ação?",
  buttonConfirm: "Sim",
  buttonCancel: "Não",
  maxWidth: "100%",
  textAlign: "center",
});
</script>

<template>
  <Teleport to="body">
    <section v-if="show" class="confirmation-dialog">
      <div class="confirm-content shadow" :style="{ maxWidth: maxWidth }">
        <div v-if="title" class="title" v-html="title"></div>
        <div
          v-if="message"
          class="message"
          :style="{ 'text-align': textAlign }"
          v-html="message"
        ></div>
        <div class="actions">
          <button class="btn btn-primary btn-md" @click="$emit('confirm')">
            {{ buttonConfirm }}
          </button>
          <button class="btn btn-md" @click="$emit('cancel')">
            {{ buttonCancel }}
          </button>
        </div>
      </div>
    </section>
  </Teleport>
</template>

<style lang="scss" scoped>
.confirmation-dialog {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--black-transparent);
  z-index: 99;

  .confirm-content {
    display: flex;
    flex-direction: column;
    background: #fff;
    padding-block: 1rem;
    padding-inline: 1.5rem;
    border-radius: 0.5rem;

    .title {
      font-size: 1.2rem;
      font-weight: bold;
      padding-block-end: 1rem;
    }

    .message {
      font-size: 1rem;
      line-height: 1.75;
      text-align: start;
      padding-block-end: 1.25rem;
    }

    .actions {
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 1rem;
    }
  }
}
</style>
